import React, { useState, useEffect } from 'react';
import { scrollWebsiteToAppStart } from './../../shared/utils/environment.js';

import ReactModal from 'react-modal';
import Icon from '../Icon/Icon';
import Register from '../Register/Register';

import "./EditProfile.scss";

export default function EditProfile(props) {

  const [isOpen, setIsOpen] = useState(true);

  // 1st render
  useEffect(() => {
    scrollWebsiteToAppStart();
  }, []);

  // handle closing
  useEffect(() => {
    if (!isOpen && typeof props.onClose == "function") {
      props.onClose();
    }
  }, [isOpen]);

  return (
    <ReactModal
      isOpen={isOpen}
      // style={styles}
      onRequestClose={() => setIsOpen(false)}
    >
      <button
        className="modal-close"
        onClick={e => {
          e.preventDefault();
          setIsOpen(false);
        }}
      >
        <Icon name="close" />
      </button>

      <Register
        type="edit"
        onSave={() => {
          setIsOpen(false);
        }}
      />

    </ReactModal>
  )

}
